
import React from 'react';
import { Lead } from '@/types/lead';
import ActivityTimeline from '@/components/ActivityTimeline';

interface ActivityTabContentProps {
  lead: Lead;
}

const ActivityTabContent: React.FC<ActivityTabContentProps> = ({ lead }) => {
  return (
    <ActivityTimeline leadId={lead.id} />
  );
};

export default ActivityTabContent;
